import { render } from "./ViewEtudiant.vue?vue&type=template&id=55536254&scoped=true&ts=true"
import script from "./ViewEtudiant.vue?vue&type=script&lang=ts"
export * from "./ViewEtudiant.vue?vue&type=script&lang=ts"

import "./ViewEtudiant.vue?vue&type=style&index=0&id=55536254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55536254"]])

export default __exports__